let captchaPresenter = null

export const WAF_FALLBACK_ERROR_MESSAGE = 'Verification failed, please try again.'

/**
 * The API layer asks React to show CAPTCHA through this small bridge.
 */
export const registerWafCaptchaPresenter = (presenter) => {
	captchaPresenter = presenter

	return () => {
		if (captchaPresenter === presenter) captchaPresenter = null
	}
}

export const presentWafCaptcha = (options) => {
	if (typeof captchaPresenter !== 'function') {
		return Promise.reject(new Error(options?.errorMessage || WAF_FALLBACK_ERROR_MESSAGE))
	}

	return captchaPresenter(options)
}
